module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chtitle"
  }, [_vm._v("VISUAL GUIDE")]), _vm._v(" "), _c('p', {
    staticClass: "figx"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("LAZY DAISY AND CHAIN STITCHES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The lazy daisy stitch can be stitched as a single unit or shape or can be repeated to create a border row. The chain stitch can be stitched as a border row or used to outline a shape.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("FLY AND FEATHER STITCHES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The fly stitch can be stitched as a single unit or shape or can be repeated to create a border row. The feather stitch can be stitched as a border row or used to outline a shape.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg7-1.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_c('i', [_vm._v("Primarily Crazy for Kevin")]), _vm._v(", project inspiration for CQ Sewing Caddy")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("CONTINUOUS BEAD AND BLANKET STITCHES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The continuous bead and blanket stitches can be stitched as a border row or used to outline a shape.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("CROSS, HERRINGBONE, SERPENTINE, AND CRETAN STITCHES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The cross stitch can be used as a single unit or as a border row. The herringbone, serpentine, and cretan stitches can be used as a border row stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg8-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("FLOWERS AND EXTRA STITCHES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("These are all individual stitches that can placed into an open area or grouped together as a vignette.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("DECORATIVE AND DETAIL STITCHES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("These stitches can be worked as a single unit, grouped together in a cluster, or used as a border row.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg9-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("BUTTON AND SEQUIN FLOWERS")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("These are all individual stitches that can be stitched here and there or grouped together as vignettes.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("BEADED EDGES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("These stitches can be added to the finished edge of a project to add a little sparkle.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg10-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("EVEN PEYOTE AND FREE-FORM PEYOTE STITCHES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("These stitches are worked onto the fabric following a straight or curved line.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("CIRCULAR PEYOTE AND NETTED STITCHES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("These stitches are worked as individual units and then attached to the fabric base.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg11-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("BRICK STITCHES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("These stitches are worked as individual units and then attached to the fabric base.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg11-2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a91ccf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_chapter01.vue
// module id = 72
// module chunks = 0